import { Link } from "react-router-dom";
import { formatCallDuration, type Call } from "@shared/modules/x-appels";
import { Badge } from "../../../core/components/ui/badge";
import { Icon } from "../../../core/components/ui/icon";
import { useElapsed } from "../lib/live";
import { prettyPhone } from "./phone-links";
import { Transcript } from "./transcript";

/**
 * Un appel en cours : qui appelle, depuis combien de temps, ce qu'il veut,
 * et la conversation qui défile. Tout est lisible à deux mètres du comptoir.
 */
export function LiveCall({ call, assistantName }: { call: Call; assistantName?: string }) {
  const elapsed = useElapsed(call.startedAt);
  return (
    <article className="live-call">
      <header className="live-call__head">
        <span className="live-call__pulse" aria-hidden="true">
          <Icon name="phone" size={22} />
        </span>
        <div className="live-call__who">
          <span className="live-call__name">{call.callerName ?? prettyPhone(call.fromNumber)}</span>
          <span className="live-call__meta">
            {call.callerName ? `${prettyPhone(call.fromNumber)} · ` : ""}
            {call.direction === "entrant" ? "Appel entrant" : "Appel sortant"}
          </span>
        </div>
        <span className="live-call__timer" aria-label="Durée">
          {formatCallDuration(elapsed)}
        </span>
        <Badge variant="live">En direct</Badge>
      </header>
      {call.intent || call.vehicle ? (
        <p className="live-call__intent">
          {call.intent ? <strong>{call.intent}</strong> : null}
          {call.intent && call.vehicle ? " · " : null}
          {call.vehicle}
        </p>
      ) : (
        <p className="live-call__intent live-call__intent--waiting">L'assistante écoute…</p>
      )}
      <Transcript lines={call.transcript} assistantName={assistantName} live tail={3} />
      <Link to={`/appels/${call.id}`} className="live-call__more">
        Suivre l'appel
        <Icon name="chevron-right" size={16} />
      </Link>
    </article>
  );
}
